import { createBrowserHistory } from 'history';

export const getBasename = (
  pathname: string,
  previewGateway = false,
): string | undefined => {
  if (previewGateway) {
    const mount = pathname.match(
      /^((?:\/__[a-z_]+__)*\/__recruiter_ui__)(?:\/|$)/,
    );
    if (mount) return mount[1];
  }
  const [, maybeShortSha] = pathname.split('/');
  return maybeShortSha.match(/^[0-9a-f]{7}$/) &&
    Number.isSafeInteger(parseInt(maybeShortSha, 16))
    ? `/${maybeShortSha}`
    : undefined;
};

export const history = createBrowserHistory({
  basename: getBasename(
    window.location.pathname,
    /--fountain\.rwx\.run$/.test(window.location.hostname) &&
      !!document.querySelector(
        'meta[name="rwx-preview-gateway"][content="true"]',
      ),
  ),
});

export default history;
